import { Button, ButtonProps } from "react-bootstrap";
import { useUser } from "../../../../hook";

interface Props extends ButtonProps {
  viewMode?: string;
  document?: any;
}

const DecentralizeReviewButton = (props: Props) => {
  const { viewMode, document, ...buttonProps } = props;
  const { checkCurrentUser } = useUser();
  const docEditors: any[] = JSON.parse(document?.docEditors ?? "[]");

  const isHasPermission = docEditors.some((item) => checkCurrentUser(item.email));

  const isCreatedUser = checkCurrentUser(document?.createdUser?.email ?? "");

  const showButton = isHasPermission || isCreatedUser;

  if (viewMode === "decentralize-preview" || !showButton) return null;
  return (
    <Button {...buttonProps} variant="info">
      Xem quyền
    </Button>
  );
};

export default DecentralizeReviewButton;
